<template>
  <div
    @click="toggleDetails"
    ref="faqItem"
    :class="['frame-group', { 'frame-group-active': showDetails }]"
  >
    <div class="wrapper">
      <b class="b">{{ title }}</b>
    </div>
    <div class="container">
      <b v-if="!showDetails" class="b1">+</b>
      <b v-else class="b1">-</b>
    </div>
  </div>
  <div v-if="showDetails" class="pescle-pesc-wrapper">
    <div class="pescle-pesc">
      <ul>
        <li v-for="detail in details" :key="detail">{{ detail }}</li>
      </ul>
      <div v-if="image" class="faq-item-image">
        <img :src="getImagePath(image.name)" :alt="image.alt" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "FAQItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getImagePath(imageName) {
      return require(`@/views/FAQ/image/${imageName}`);
    },
  },
  setup() {
    const showDetails = ref(false);
    const faqItem = ref(null);

    const toggleDetails = () => {
      showDetails.value = !showDetails.value;
    };

    return {
      showDetails,
      faqItem,
      toggleDetails,
    };
  },
};
</script>

<style scoped>
/* 通常のスタイル */
.wrapper {
  align-self: stretch;
  width: 535px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.b1 {
  align-self: stretch;
  position: relative;
}
.container {
  width: 28px;
  align-items: flex-end;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  color: #5b5555;
  font-family: Inter;
}
.frame-group {
  align-self: stretch;
  border-radius: 20px;
  background-color: #eee;
  border: 1px solid #eee;
  box-sizing: border-box;
  min-height: 65px;
  height: auto;
  margin-bottom: 10px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 11px 21px;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  margin-left: 20px;
}
.frame-group:hover {
  background-color: #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.frame-group-active {
  background-color: #ccc;
  border: 1px solid #ccc;
}
.pescle-pesc-wrapper {
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 20px;
  font-size: 15px;
  color: #807f7f;
  font-family: Inter;
  margin-left: 20px;
}

/* レスポンシブデザイン */
@media (max-width: 768px) {
  .wrapper {
    width: 100%;
    padding: 0 10px;
  }

  .frame-group {
    margin-left: 0;
    width: 100%;
    height: auto;
    padding: 10px;
  }

  .frame-group:hover {
    background-color: #eee;
    box-shadow: none;
  }

  .pescle-pesc-wrapper {
    padding: 10px;
    margin-left: 0;
  }

  .container {
    font-size: 18px;
  }
}
</style>
